package modysy.tools

import modysy.GameController
import modysy.datastructures.Vector2
import modysy.model.{GameObject, Transform}

/** A tool for placing objects into the game world.
  * The toolbox supports touch based placement for the PlacementTool
  *
  * @see Toolbox
  */
trait PlacementTool extends Tool {
  protected val gameController: GameController

  protected var currentOrientation: Double

  /** A dummy object used to check for collisions with objects already
    * present in the level. */
  protected def placedObject: GameObject

  def isPlaceable(worldPos: Vector2): Boolean = {
    val obj = placedObject
    obj.body.pose = Transform.rotate(currentOrientation).translate(worldPos)

    val objInsideInnerField = gameController.getLevel.innerField
      .containsFully(obj.body.pose, obj.body.geometry)

    val objDoesNotCollide = gameController.collisionEngine
      .calculateCollisions(obj)
      .isEmpty

    objInsideInnerField && objDoesNotCollide
  }

  def isOver(worldPos: Vector2): Boolean = {
    require(
      _position.isDefined,
      "called isOver(...) but PlacementTool not positioned"
    )

    placedObject.body.pose =
      Transform.rotate(currentOrientation).translate(_position.get)
    placedObject.body.contains(worldPos)
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/tools/PlacementTool.scala